import { Grid } from '@mui/material';
import {
  WsTypography,
  EmptyTeamsAndUsersIcon,
  WsTypoVariants,
  WsColors,
  WsTypoColors,
} from 'wisestep-base';

const EmptyContentMessage = ({ title, subtitle, marginTop = 2, height = 600 }) => (
  <Grid
    container
    rowSpacing={1}
    px={2}
    py={2.2}
    sx={{
      backgroundColor: WsColors.White,
      height: height,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      mt: marginTop,
    }}
  >
    {<EmptyTeamsAndUsersIcon />}
    <Grid item>
      <WsTypography variant={WsTypoVariants.SUB_TITLE} bold={true}>
        {title}
      </WsTypography>
    </Grid>
    <Grid item>
      <WsTypography color={WsTypoColors.SECONDARY} variant={WsTypoVariants.SUB_TITLE}>
        {subtitle}
      </WsTypography>
    </Grid>
  </Grid>
);

export default EmptyContentMessage;
